

import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { LockService } from 'src/app/Services/LockService/lock-service.service';
import { Defaults } from 'src/app/Utilities/defaults';
import { IPatientForms } from 'src/app/models/IPatientForms';
import { IPatientReferrals } from 'src/app/models/IPatientReferrals';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { PatientformService } from 'src/app/Services/PatientForms/patientform.service';
import { ToastrService } from 'ngx-toastr';
import { IAttributes } from 'src/app/models/IAttributes';
import { ConsentFormsClinicService } from 'src/app/Services/NewORNote/consentForm.service';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { DatePipe } from '@angular/common';
import { MatTableDataSource, MatPaginator, MatDialog, MatTabChangeEvent } from '@angular/material';
import { ConfirmDialogModel, DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { IPatientPersonalInfo } from 'src/app/models/IPatientPersonalInfo';
import { IReportParameters } from 'src/app/models/IReportParameters';
import { ShowSSRSReportComponent } from 'src/app/ChildControls/show-ssrsreport/show-ssrsreport.component';
import { SharedService } from '../Sharedservice/SharedService';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component_RoleMasterEnum, UserRoleservice } from '../Services/common.service';
import { AuditLog } from '../models/iauditlog.model';
import { IEncounterData } from '../models/IEncounterData';
import { configuration } from 'src/environments/environment';
import { AESAlgorithm } from '../Utilities/Crypto/AESAlgorithm';

@Component({
  selector: 'app-doc-lib-emrconsent-forms',
  templateUrl: './doc-lib-emrconsent-forms.component.html',
  styleUrls: ['./doc-lib-emrconsent-forms.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DocLibEMRConsentFormsComponent implements OnInit {




  //@ViewChild("signaturePad", null) signaturePad: SignaturePad;
  @ViewChild(SignaturePad, null) signaturePad: SignaturePad;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  signaturePadOptions = {
    minWidth: 0.4,
    maxWidth: 1.7,
    dotSize: 1.5,
    // penColor: "DarkBlue",

    'canvasWidth': 510,
    'canvasHeight': 200
  }

  // columnsToDisplay = ['FormName', 'EffectiveDate', 'ExprirationDate', 'Status', 'Action'];'Status',
  //columnsToDisplay = ['practiceFormTitle', 'effective', 'expiration', 'activeStatus', 'Action'];
  columnsToDisplay = ['Form Name', 'Effective Date', 'Expiration Date', 'Action'];
  expandedElement: any | null;



  date = new FormControl(new Date());
  serializedDate = new FormControl((new Date()).toISOString());


  public show: boolean = false;
  public hide: boolean = false;
  public encounterId: string;
  widgetposition = 6;//  3;
  forms: FormGroup;
  submitted = false;
  patientReferralDetails: IPatientReferrals;
  public personalInfo: IPatientPersonalInfo;
  consentDetails: IAttributes[];
  //activetab = 10;
  activetab = 9;
  activeORtab = 1;
  lockedUser: any;
  lockMessage: any;
  public result: any;
  userId: string;
  allPatientDetails: IPatientForms[] = [];
  patientInfo: IPatientForms[] = [];
  patientFormDataSource = new MatTableDataSource(this.allPatientDetails);
  patientDetails: IPatientForms;
  public patientNameById: number;
  showAllD: string = 'Show All Status';
  headerVisibility: boolean;
  UserPermissions: string = "";
  public DocLibTargetLocID: number = 0;
  public Isdashboard: boolean = false;
  public dashboardname: string;
  constructor(//private app: AppComponent,
    private patientformService: PatientformService,
    private formBuilder: FormBuilder,
    private lockService: LockService,
    private route: ActivatedRoute,
    private personalService: PersonalInfoService,
    private sharedService: SharedService,
    private toastr: ToastrService,
    private IConsentformsService: ConsentFormsClinicService,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe,
    private router: Router,
    private _userRoleservice: UserRoleservice,
    public dialog: MatDialog
    , private route1: ActivatedRoute, private crypto: AESAlgorithm) {
    // app.isLoggedIn$ = true;
    this.getSystem();
    this.headerVisibility = CommonComponents.demoheaderVisibility;
    this.encounterId = CommonComponents.encounterId;
    this.DocLibTargetLocID = Number(this.route.snapshot.paramMap.get('DocLibTargetLocID'));
    this.checkLock();
    //this.getVisitIsSignedoff();
    this.UserPermissions = this._userRoleservice.getPermissionsByComponentId(Component_RoleMasterEnum.Form);
  }

  formErrors = {
    'practiceForm': '',
  };

  validationMessages = {
    'practiceForm': {
      'required': 'Practice Form is required.',
    },

  };

  screenActionName: string = "";
  ngOnInit() {
    try {
      this.route1.queryParams.subscribe(params => {
        this.dashboardname = this.crypto.urlParmeterDecoder(decodeURIComponent(params['screen']));
        this.screenActionName = params['Type'];
        if (this.dashboardname == 'dashboard') {
          localStorage.setItem("isBackBtnVisibleInVisitNotes", "1")
        }
        else {
          if (localStorage.getItem("isBackBtnVisibleInVisitNotes") == "1")
            localStorage.setItem("isBackBtnVisibleInVisitNotes", "1");
          else
            localStorage.setItem("isBackBtnVisibleInVisitNotes", "0");
        }
      }, (err: any) => {
        console.log(err);
        // this.spinner.hide();
      });

      this.spinner.show()
      this.forms = this.formBuilder.group({
        patientForms: [''],
        // showAll:[''],

      });
      if (CommonComponents.patientId == null || CommonComponents.patientId == undefined || CommonComponents.patientId == 0) {
        this.toastr.error("Please Select Patient");

        //this.router.navigateByUrl('/Appointments');
        this.forms.disable();
        this.isdisablebtn = true;
      }

      this.DocLibTargetLocID = Number(this.route.snapshot.paramMap.get('DocLibTargetLocID'));
      // if(this.route.snapshot.paramMap.get('DocLibTargetLocID')!= undefined)
      //     this.DocLibTargetLocID = Number(this.route.snapshot.paramMap.get('DocLibTargetLocID'));
      //  else
      //    this.route.queryParams.subscribe(params=>{this.DocLibTargetLocID=params['DocLibTargetLocID']});
      if (this.DocLibTargetLocID == Defaults.DocLibraryCheckinForm) {
        this.headerVisibility = false;
        CommonComponents.demoheaderVisibility = false;
        this.widgetposition = 5;
      }
      else if (this.DocLibTargetLocID == Defaults.DocLibraryVisitNote) {
        this.activetab = 22;//18;
        if (sessionStorage.getItem("pumPRefillVisibility") != "True") {
          this.activetab = this.activetab - 1;
        }

      }
      else if (this.DocLibTargetLocID == Defaults.DocLibraryORNote) {
        this.activetab = 4;
      }
      else if (this.DocLibTargetLocID == Defaults.DocLibraryPatDemographicsID) {
        this.activetab = 9;
      }

      this.patientNameById = Number(sessionStorage.getItem("patientId"));// CommonComponents.patientId;
      if (this.patientNameById)
        this.getPatientFormsDetails(this.patientNameById, this.DocLibTargetLocID, true);

        if (localStorage.getItem("isBackBtnVisibleInVisitNotes") && localStorage.getItem("isBackBtnVisibleInVisitNotes") == "1")
        this.Isdashboard = true;
        else if (localStorage.getItem("isBackBtnVisibleInVisitNotes") && localStorage.getItem("isBackBtnVisibleInVisitNotes") == "0")
        this.Isdashboard = false;
      // this.patientFormDataSource.paginator = this.paginator;
    }
    catch (ex) {
      this.spinner.hide();
    }
    finally {
      setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
      }, 1000);
    }
  }
  fnIsUserGotAccess(type: string): boolean {
    // Only Checking for Patient Demographics
    if (this.headerVisibility && this.DocLibTargetLocID == this.getHeaderLocationId('D')) {
      if (type != '')
        return this.UserPermissions.indexOf(type) > -1

    }
    return true;
  }
  get f() { return this.forms.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.forms.invalid) {
      return;
    }
  }

  getSystem() {
    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
    // if (sessionStorage.getItem("demoheaderVisibility") != null || sessionStorage.getItem("demoheaderVisibility") != undefined) {
    //   CommonComponents.demoheaderVisibility = Boolean(sessionStorage.getItem("demoheaderVisibility"));
    // }
  }
  tabChanged(tablabelname: string) {
    this.deleteUserLock();
    let str = tablabelname.replace(" ", "")
    this.router.navigateByUrl('/' + str);
  }
  /* tabChangedOR(event: MatTabChangeEvent){
     let str= event.tab.textLabel.replace(" ", "");
     this.router.navigateByUrl('/OR' +str);
   }
   tabChangedOR(event: MatTabChangeEvent){*/
  tabChangedOR(event: MatTabChangeEvent, Maintype: string) {
    if (Maintype == 'Head') {

      this.isAuthorizationSigned(event);
    }
    else {
      //  this.spinner.hide();
      // this.router.navigateByUrl('/OR' + event.tab.textLabel.replace(" ", ""));
      var tabName = event.tab.textLabel.replace(" & ", "");
      if (tabName == 'COVID-19 Risk Disclosure') {
        //var tabname1 = 'Vertiflex';
        this.router.navigateByUrl('/OR' + tabName.replace("-", "").replace(" ", "").replace(" ", ""));
      }
      else {
        this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
      }
    }
  }
  deleteUserLock() {
    if (sessionStorage.getItem("userId") != undefined && sessionStorage.getItem("userId") != null) {
      this.lockService.deleteLockUsersInfo(sessionStorage.getItem("userId")).subscribe(data => {
        this.result = data;
      }, (err: any) => {
        console.log(err);
        this.spinner.hide();
      });
    }
  }
  isAuthorizationSigned(event: any) {
    var tabName = event.tab.textLabel.replace(" & ", "");
    this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));

    // if (event.tab.textLabel === "Allergies & A/Cs") {
    //   var tabName = event.tab.textLabel.replace(" & ", "");
    //   this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
    //   return;
    // }
    // this.sharedService.getAuthSignOffStatus(sessionStorage.getItem("encounterid"))
    //   .subscribe(
    //     results => {
    //       if (results == "1") {
    //         var tabName = event.tab.textLabel.replace(" & ", "");
    //         this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
    //       }
    //       else {
    //         this.checkLock();
    //         const message = `Authorization Consent Form should be signed before proceeding `;
    //         const dialogData = new warningDialogModel('Alert !', message);
    //         const dialogRef = this.dialog.open(WarningDialogComponent, {
    //           maxWidth: '400px',
    //           height: '160px',
    //           data: dialogData
    //         });

    //         this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    //           this.router.navigate(['/ORConsents']));
    //       }

    //     }
    //   );
  }
  getHeaderLocationId(type: string) {
    if (type == "D")
      return Defaults.DocLibraryPatDemographicsID;
    else if (type == "C")
      return Defaults.DocLibraryCheckinForm;
    else if (type == "V")
      return Defaults.DocLibraryVisitNote;
    else if (type == "O")
      return Defaults.DocLibraryORNote;
  }
  showInfo() {

    if (this.DocLibTargetLocID == Defaults.DocLibraryPatDemographicsID)
      this.router.navigate(['Demographics/ConsentNewForms/' + this.DocLibTargetLocID]);
    // else if(this.DocLibTargetLocID==Defaults.DocLibraryVisitNote)
    //  this.router.navigateByUrl('ConsentForms?DocLibTargetLocID='+ Defaults.DocLibraryVisitNote);
    else {
      this.headerVisibility = false;
      CommonComponents.demoheaderVisibility = false;
      this.router.navigate(['/ConsentNewForms/' + this.DocLibTargetLocID]);
    }
  }

  ischecked: boolean = false;
  showAllPatients(event: any) {
    //if (event.target.checked) {
    this.getPatientFormsDetails(this.patientNameById, this.DocLibTargetLocID, event.target.checked);
    this.ischecked = event.target.checked;
    /*}
    else {
      this.getPatientFormsDetails(this.patientNameById,this.DocLibTargetLocID, true);
      this.ischecked = false;
    }*/
  }


  async getPatientFormsDetails(patientNameById, TargetLocationID, showAll: boolean) {
    try {
      this.spinner.show();
      if (patientNameById != null || patientNameById != undefined) {
        await this.patientformService.getPatientFormInfoDocLib(patientNameById, TargetLocationID, showAll).subscribe(
          data => {
            this.allPatientDetails = data;
            this.patientFormDataSource.data = this.allPatientDetails;
            this.patientFormDataSource.paginator = this.paginator;
            this.AuditLogs("USP_GET_PATIENT_FORM_DOCLIB".concat(TargetLocationID.toString()), "<" + patientNameById + ">" + " <" + TargetLocationID + ">" + " <" + showAll + ">");
          }, (err: any) => console.log(err));
      }
    }
    catch (ex) {  }
    finally {
      setTimeout(() => {
        this.spinner.hide();
      }, 2000);
    }
  }

  ondeleteclick(PatinetFormId: number) {
    //this.delInsInfo = delNo;
    const message = "Are you sure to delete this Form ? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '400px',
      height: '120px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.expandedElement = null;
      //  this.delInsInfo = "";
      this.result = dialogResult;
      if (this.result) {
        // const message = "Are you sure to delete ICD Code from selected encounter? ";
        // const dialogData = new ConfirmDialogModel('Confirm Action', message);
        // const dialogRef = this.dialog.open(DeleteDocumentComponent, {
        //   maxWidth: '400px',
        //   data: dialogData
        // });
        this.patientformService.DocLibdeleteFormDetails(PatinetFormId).subscribe(
          results => {
            this.result = results;
            this.toastr.success(this.result);
            //var chkVal=this.forms.value.showAll;
            var status: boolean;
            if (this.ischecked == false) {
              status = true;
            } else {
              status = false;
            }
            this.getPatientFormsDetails(this.patientNameById, this.DocLibTargetLocID, status);
          }
        );
      }
      else {
        this.result = dialogResult;
      }
    });
  }
  //patientFormDetails: IPatientForms
  modifyForm(PatinetFormId: number) {

    this.router.navigate(['Demographics/ConsentEditForms', this.DocLibTargetLocID, PatinetFormId]);
  }
  isdisablebtn: boolean = false;
  DisableFormConsent: string;
  // checkLock() {
  //    
  //   var formname="Forms"+this.DocLibTargetLocID;
  //  // alert(formname);
  //   //this.lockService.getLockUsers(encodeURIComponent(sessionStorage.getItem("userId")), Defaults.lock_demographics_consentforms, sessionStorage.getItem("FacilityId"), CommonComponents.patientId.toString()).subscribe(
  //     this.lockService.getLockUsers(encodeURIComponent(sessionStorage.getItem("userId")), formname, sessionStorage.getItem("FacilityId"), CommonComponents.patientId.toString()).subscribe(

  //     results => {
  //        
  //       this.lockedUser = results;
  //       if (this.lockedUser != null && this.lockedUser != undefined) {
  //         this.lockMessage = this.lockedUser.userName + " is working on this " + this.lockedUser.controlName + " form right now ";
  //         this.forms.disable();
  //         // this.disabledSaveSignoffButton = true;
  //          this.isdisablebtn = true;
  //          this.DisableFormConsent='DisableFormConsent';
  //          this.toastr.error(this.lockMessage);
  //         }
  //         else{
  //           this.DisableFormConsent='';
  //         }
  //     });
  // }
  checkLock() {
    var formname = "Doclib_ConsentForms_" + this.DocLibTargetLocID;
    var encID_patid = 'PATID' + CommonComponents.patientId.toString();
    if (sessionStorage.getItem("encounterid") && sessionStorage.getItem("encounterid") != '') {
      encID_patid = encID_patid + sessionStorage.getItem("encounterid");
    }
    else {
      encID_patid = encID_patid;
    }
    this.lockService.getLockUsers(encodeURIComponent(sessionStorage.getItem("userId")), formname, sessionStorage.getItem("FacilityId"), encID_patid)
      .subscribe(
        results => {
          this.lockedUser = results;
          if (this.lockedUser != null && this.lockedUser != undefined) {

            this.forms.disable();
            this.isdisablebtn = true;
            this.DisableFormConsent = 'DisableFormConsent';
            //  this.toastr.error("user is already working on the same form");
            //  this.signaturePad.off();
            //  this.lockMessage = this.lockedUser.userName + " is working on this " + this.lockedUser.controlName + " form right now ";
            this.lockMessage = this.lockedUser.userName + " is working on this Document Library form right now ";
            //  this.toastr.error(this.lockMessage);

          }
          else {
            this.DisableFormConsent = '';
          }
          // this.signaturePad2.off();
          // this.hidelock = true;
          // this.callSave = false;
          //this.signaturePad.off();
          //this.SignOffClicked = true;
          // this.consentimpclearButtons = true;
          // this.isShown = false;
          // this.hideimplock = false;
          // this.hideimpunlock = true;
          // this.isconsentimpNursename = true;
          // this.consentimpNursedisabledButton = true;
          // this.consentimpsavedisabledButton = true;
          // this.consentimpsavetochartdisabledButtons = true;
          // this.consentforms.controls.PatientSignOffDateTime.disable();
          // this.consentforms.controls.PhySignOffDateTime.disable();
          // this.consentforms.controls.ImpInstDate.disable();
          // this.SignOffClickedimpnurse = true;
          // this.SignOffClicked = true;
          // //this.disabledButtons = true;
          // this.disabledprevButtons = true;
          // this.signaturePad.off();
          //this.NursedisabledButtons = true;
          // this.hidelocks = false;
          // this.hideunlocks = true;
          // this.NursedisabledButtons = true;
          // this.isAuthconsentdoctors = true;
          // this.isAuthconsentWitnessname = true;
          // this.consentforms.controls.AuthorizationDate.disable();
          // this.consentforms.controls.patientSignOffDate.disable();
          // this.consentforms.controls.WitnessSignOffDate.disable();
          // this.SignOffClickedauthnurse = true;
          //  this.hidelockverti = false;
          //  this.hideunlockverti = true;
          // this.vertiflexrepresentativeSignOffdisabled = true;
          // this.vertiflexSavedisabled = true;
          // this.isVertflexSelect = true;
          // this.consentforms.controls.vertiflexPhySignOffDateTime.disable();
          // this.isVertiflexClear = true;
          // this.isVFSignDisable = true;
          // this.SignOffClickedvertxnurse = true;
          // this.spinalCordrepresentativeSignOffdisabled = true;
          // this.spinalCordSavedisabled = true;
          // this.isSpinalCordSelect = true;
          // this.consentforms.controls.spinalCordPhySignOffDateTime.disable();
          // this.isSpinalCordClear = true;
          // this.isSCSignDisable = true;
          // // this.hidelockspin = false;
          // // this.hideunlockspin = true;
          // this.SignOffClickedspinnurse = true;
          // }
          //this.callSave = false;
        });

  }

  public signoffEnc: IEncounterData;
  getVisitIsSignedoff() {
    if (this.encounterId != undefined) {
      this.sharedService.getIsSignedoff(this.encounterId, 1).subscribe(data => {
        this.signoffEnc = data;
        if (data != undefined) {
          if (this.signoffEnc.isSignOff == true && this.signoffEnc.lockedby == null && this.signoffEnc.islockorUnlock === false) {
            this.forms.disable();
            this.DisableFormConsent = 'DisableFormConsent';
          }
          else if (this.signoffEnc.isSignOff == true && this.signoffEnc.lockedby == sessionStorage.getItem("userId") && this.signoffEnc.islockorUnlock === true) {
            this.forms.enable();
            this.checkLock();
          }
          else if (this.signoffEnc.isSignOff == true && this.signoffEnc.lockedby != sessionStorage.getItem("userId") && this.signoffEnc.islockorUnlock === false) {
            this.forms.disable();
            this.DisableFormConsent = 'DisableFormConsent';
          }
          else {
            this.forms.enable();
            this.checkLock();
          }
        }
        else {
          this.DisableFormConsent = '';
        }
      });
    }
  }
  public reportParamters: IReportParameters;
  previewReport(PatientFormID: string) {
    // alert(PatientFormID);
    //alert(this.patientFormId);
    let reportParamters = new IReportParameters();
    reportParamters.reportUrl = configuration.reportsUrl + "/ConsentFormRpt"; //'NEMR/ConsentForms';
    reportParamters.parameters = {
      "EMRConsentFormID": PatientFormID
    };
    const dialogRef = this.dialog.open(ShowSSRSReportComponent, {
      width: '850px',
      height: '100%',
      data: reportParamters
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  public _auditLog: AuditLog;
  AuditLogs(sp: any, input: any) {
    this._auditLog = new AuditLog();
    this._auditLog.InputParameters = input;
    this._auditLog.SPName = sp;
    this.sharedService.selectCopyPrintAuditLog(this._auditLog).subscribe(async result => {
      await result;
    });
  }
  ngAfterViewInit() {
    this.signaturePad.clear();
    if (this.route1.snapshot.queryParams["screen"] && this.route1.snapshot.queryParams['screen'].length > 0) {
      this.Isdashboard = true;
    } else {
      if (localStorage.getItem("isBackBtnVisibleInVisitNotes") == "1")
        this.Isdashboard = true;
      else
        this.Isdashboard = false;
    }
  }
  Backtodashboard() {
    //this.router.navigateByUrl('/providerdashboard');
    CommonComponents.demoheaderVisibility = true; 
    this.router.navigateByUrl('/', { skipLocationChange: true, queryParamsHandling: 'preserve' }).then(() =>
    this.router.navigateByUrl('/providerdashboard?isPN=true'));

  }
}


